import { Controller } from 'stimulus'
import '@pixi/polyfill'
import { GlitchFilter } from 'pixi-filters'
import { Application, Text, TextStyle, Graphics, Container, BLEND_MODES, utils } from 'pixi.js'
import {RGBSplitFilter} from '@pixi/filter-rgb-split';
import gsap from 'gsap'

export default class extends Controller {
  static targets = ['canvas', 'words']
  static dpr
  static hideHeight
  static pixiApp

  connect() {
    this.dpr = window.devicePixelRatio || 1
    this.hideHeight = window.innerHeight
    this.items = document.querySelectorAll(".js-glitch-item")
  }

  animate(count) {
    const matchMedia = window.matchMedia('(max-width: 768px)').matches
    // if (matchMedia) return
    if (this.pixiApp) return

    const $canvas = this.canvasTarget
    let $words
    if (count === 1) {
      $words = [this.wordsTargets[0], this.wordsTargets[1]];
    } else if (count === 2) {
      $words = [this.wordsTargets[2], this.wordsTargets[3]];
    } else if (count === 3) {
      $words = [this.wordsTargets[4], this.wordsTargets[5]];
    }

    const getWordArr = () => {
      let _arr = []
      let _flg = false
      $words.map((word) => {
        if (!_flg) {
          _arr.push(...word.querySelectorAll(".Word__text"))
          _flg = true
        } else {
          _arr = _arr.concat(...word.querySelectorAll(".Word__text"))
        }
      })
      return _arr
    }

    this.pixiApp = new Application({
      width: window.innerWidth,
      height: window.innerHeight,
      antialias: true,
      resolution: this.dpr,
      resizeTo: window,
      backgroundAlpha: 0,
    })

    const
    view = this.pixiApp.view,
    stage = this.pixiApp.stage,
    ticker = this.pixiApp.ticker;
    ticker.speed = 0.001
    $canvas.appendChild(view)
    if (this.dpr > 1) view.style.transform = `scale(${1 / this.dpr})`

    const texts = Array.from(getWordArr()).map(($word) => {
      const _text = $word.innerText
      const _position = $word.getBoundingClientRect()
      const _style = getComputedStyle($word)
      const _width = Math.floor(Number(_style.width.replace('px', '')))
      const _height = Math.floor(Number(_style.height.replace('px', '')))
      const _fontSize = Math.floor(Number(_style.fontSize.replace('px', '')))
      const _dataset = $word.dataset

      this.container = new Container()

      const _textStyle = new TextStyle({
        wordWrap: true,
        breakWords: true,
        whiteSpace: 'normal',
        fill: _dataset.fill,
        fontFamily: _style.fontFamily,
        fontSize: _fontSize,
        lineHeight: Number(_style.lineHeight.replace('px', '')),
      })
      const _pixiText = new Text(_text, {
        fill: _textStyle.fill,
        fontFamily: _textStyle.fontFamily,
        fontSize: _textStyle.fontSize,
        lineHeight: _textStyle.lineHeight,
        textBaseline: 'baseline',
        wordWrap: true,
        breakWords: true,
        wordWrapWidth: _width,
        align: 'center',
      })
      // _pixiText.x = _position.left + window.pageYOffset
      // _pixiText.y = _position.top + window.pageXOffset
      _pixiText.x = _position.left
      _pixiText.y = _position.top

      if (!_dataset.glitchHasBackground && !_dataset.glitchHasBorder) {

        setTimeout(() => {
          this.container.addChild(_pixiText)
        }, Math.floor(Math.random() * (6 - 4) + 4) * 100)
        stage.addChild(this.container)
        return _pixiText
      }

      if (_dataset.glitchHasBackground) {
        const _fillRect = this.getFillRect(_position, _width, _height)
        _pixiText.blendMode = BLEND_MODES.XOR
        this.container.addChild(_fillRect)
      }

      if (_dataset.glitchHasBorder) {
        const _lineRect = this.getLineRect(_position, _width, _height)

        setTimeout(() => {
          this.container.addChild(_lineRect)
        }, Math.floor(Math.random() * (6 - 4) + 4) * 100)
      }

      this.container.addChild(_pixiText)
      stage.addChild(this.container)

      return _pixiText
    })

    this.pixiGlitchFilter = new GlitchFilter()
    stage.filters = [this.pixiGlitchFilter]

    this.offsetValue = 100
    this.slicesValue = 30

    const loop = () => {
      this.intervalId = setInterval(() => {
        this.pixiGlitchFilter.slices = Math.floor(Math.random() * 10) + this.slicesValue
        this.pixiGlitchFilter.offset = Math.floor(Math.random() * 10) + this.offsetValue
      }, 50);
    }

    loop()

  }

  randomIntFromInterval(min, max) {
    return Math.random() * (max - min + 1) + min
  }

  display() {

    let
    scrollTop = window.pageYOffset

    const
    triggerValue = document.body.clientHeight / 4,
    scrollFlg = [false, false, false],
    scrollEv = () => {
      scrollTop = window.pageYOffset

      if (scrollTop <= 500) scrollFlg[0] = false

      if (scrollTop >= triggerValue*3) {
        if (!scrollFlg[2]) {
          this.animate(3)
          setTimeout(() => {
            this.glitchItem()
          }, 300);
          setTimeout(() => {
            this.offsetValue = 3
            this.slicesValue = 3
            setTimeout(() => {
              this.offsetValue = 200
              this.slicesValue = 30
              this.destroyCanvas()
            }, 1000);
          }, 700)
          // this.stopCanvas()
          scrollFlg[0] = false
          scrollFlg[1] = false
          scrollFlg[2] = true
        }
      } else if (scrollTop >= triggerValue*2) {
        if (!scrollFlg[1]) {
          this.animate(2)
          setTimeout(() => {
            this.glitchItem()
          }, 300);
          setTimeout(() => {
            this.offsetValue = 3
            this.slicesValue = 3
            setTimeout(() => {
              this.offsetValue = 200
              this.slicesValue = 30
              this.destroyCanvas()
            }, 1000);
          }, 700)
          // this.stopCanvas()
          scrollFlg[0] = false
          scrollFlg[1] = true
          scrollFlg[2] = false
        }
      } else if (scrollTop >= triggerValue) {
        if (!scrollFlg[0]) {
          this.animate(1)
          setTimeout(() => {
            this.glitchItem()
          }, 300);
          setTimeout(() => {
            this.offsetValue = 3
            this.slicesValue = 3
            setTimeout(() => {
              this.offsetValue = 200
              this.slicesValue = 30
              this.destroyCanvas()
            }, 1000);
          }, 700)
          // this.destroyCanvas()
          scrollFlg[0] = true
          scrollFlg[1] = false
          scrollFlg[2] = false
        }
      }
    }
    window.addEventListener("scroll", scrollEv)
  }

  stopCanvas() {
    setTimeout(() => {
      if (!this.pixiApp) { return }
      this.pixiGlitchFilter = null
    }, 1000)
  }

  destroyCanvas() {
    setTimeout(() => {
      if (!this.pixiApp) { return }
      this.pixiApp.destroy({baseTexture: true, texture: true, children: true})
      this.pixiApp = null
      clearInterval(this.intervalId)
      clearInterval(this.rgbIntervalId)
    }, 180)
  }

  getHex(color) {
    if (color.indexOf('#') != -1) return color

    const _rgb = color.replace('rgb(', '').replace(')', '').replace(/\s+/g, '')
    const _array = _rgb.split(',').map((_value) => {
      const _number = (Number(_value) / 255)
      return _number
    })
    return utils.rgb2hex(_array)
  }

  getFillRect(position, width, height) {
    const rect = new Graphics()
      .beginFill(0x0e245d)
      .drawRect(
        // position.left + window.pageYOffset,
        // position.top + window.pageXOffset,
        position.left,
        position.top,
        width,
        height
      )
      .endFill()

    //   const _rgbFilter = new RGBSplitFilter()
    //   this.rgbAnimate(_rgbFilter)
    // rect.filters = [_rgbFilter]

    return rect
  }

  getLineRect(position, width, height) {
    const lineRect = new Graphics()
      .lineStyle(4, 0x0e245d, 1, 1)
      .drawRect(
        // position.left + window.pageYOffset,
        // position.top + window.pageXOffset,
        position.left,
        position.top,
        width,
        height
      )

    // const _rgbFilter = new RGBSplitFilter()
    // lineRect.filters = [_rgbFilter]

    return lineRect
  }

  glitchItem() {
    for (let i = 0; i < 2; i++) {
      const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
      this.items[randomCount].style.opacity = "1"
      setTimeout(() => {
        this.items[randomCount].style.opacity = "0"
      }, 80);
    }
    setTimeout(() => {
      for (let i = 0; i < 2; i++) {
        const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
        this.items[randomCount].style.opacity = "1"
        setTimeout(() => {
          this.items[randomCount].style.opacity = "0"
        }, 80);
      }
      setTimeout(() => {
        for (let i = 0; i < 2; i++) {
          const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
          this.items[randomCount].style.opacity = "1"
          setTimeout(() => {
            this.items[randomCount].style.opacity = "0"
          }, 80);
        }
        setTimeout(() => {
          for (let i = 0; i < 2; i++) {
            const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
            this.items[randomCount].style.opacity = "1"
            setTimeout(() => {
              this.items[randomCount].style.opacity = "0"
            }, 80);
          }
          setTimeout(() => {
            for (let i = 0; i < 2; i++) {
              const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
              this.items[randomCount].style.opacity = "1"
              setTimeout(() => {
                this.items[randomCount].style.opacity = "0"
              }, 80);
            }
            setTimeout(() => {
              for (let i = 0; i < 2; i++) {
                const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
                this.items[randomCount].style.opacity = "1"
                setTimeout(() => {
                  this.items[randomCount].style.opacity = "0"
                }, 80);
              }
              setTimeout(() => {
                for (let i = 0; i < 2; i++) {
                  const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
                  this.items[randomCount].style.opacity = "1"
                  setTimeout(() => {
                    this.items[randomCount].style.opacity = "0"
                  }, 80);
                }
                setTimeout(() => {
                  for (let i = 0; i < 2; i++) {
                    const randomCount = Math.floor(Math.random() * (9 - 0) + 0)
                    this.items[randomCount].style.opacity = "1"
                    setTimeout(() => {
                      this.items[randomCount].style.opacity = "0"
                    }, 80);
                  }
                }, 100);
              }, 100);
            }, 100);
          }, 100);
        }, 100);
      }, 100);
    }, 100);
  }
}
